(function () {
  if (window.__ksHideSmileOnCartDrawer) return;
  window.__ksHideSmileOnCartDrawer = true;

  const LOG = '[KS Hide Smile Rewards]';

  const smileSelectors = [
    '#smile-ui-lite-launcher-frame-container',
    '#smile-lite-launcher-frame',
    '[id*="smile-ui-lite-launcher"]',
    '[id*="smile-lite-launcher"]'
  ];

  function getCartDrawer() {
    return (
      document.querySelector('cart-drawer#cart-drawer') ||
      document.querySelector('#cart-drawer') ||
      document.querySelector('.drawer--cart')
    );
  }

  function isCartDrawerOpen() {
    const drawer = getCartDrawer();

    if (!drawer) return false;

    return (
      drawer.classList.contains('is-open') ||
      drawer.classList.contains('drawer--is-open') ||
      drawer.classList.contains('is-active') ||
      drawer.getAttribute('aria-hidden') === 'false' ||
      drawer.hasAttribute('open')
    );
  }

  function getSmileLaunchers() {
    const launchers = [];

    smileSelectors.forEach(selector => {
      document.querySelectorAll(selector).forEach(el => {
        if (!launchers.includes(el)) {
          launchers.push(el);
        }
      });
    });

    return launchers;
  }

  /* 固定在底部的關鍵按鈕列：商家團組合箱、段純貞、台美直郵購物車 bar。
     Rewards 圖示只要壓到其中任何一條就藏起來（2026-10-26 owner）。 */
  const criticalCtaSelectors = '.kscb__cta, .ksbb__bar, #ks-sticky-cart-bar:not(.is-hidden)';

  function visibleRect(el) {
    const s = window.getComputedStyle(el);
    if (s.display === 'none' || s.visibility === 'hidden') return null;
    const r = el.getBoundingClientRect();
    if (!r.width || !r.height || r.bottom <= 0 || r.top >= window.innerHeight) return null;
    return r;
  }

  function overlaps(a, b) {
    return a.left < b.right && a.right > b.left && a.top < b.bottom && a.bottom > b.top;
  }

  // 藏起來之後量不到位置，所以記住最後一次看得到時的位置
  function launcherRect(el) {
    if (el.getAttribute('data-ks-hidden-by-cta') !== 'true') {
      const r = visibleRect(el);
      if (r) el.__ksLastRect = { left: r.left, right: r.right, top: r.top, bottom: r.bottom };
    }
    return el.__ksLastRect || null;
  }

  function coversCriticalCta(el) {
    const lr = launcherRect(el);
    if (!lr) return false;
    return Array.prototype.some.call(document.querySelectorAll(criticalCtaSelectors), function (cta) {
      const r = visibleRect(cta);
      return !!r && overlaps(lr, r);
    });
  }

  function updateSmileVisibility() {
    const drawerOpen = isCartDrawerOpen();
    const launchers = getSmileLaunchers();

    launchers.forEach(el => {
      const shouldHide = drawerOpen || coversCriticalCta(el);
      if (shouldHide && !drawerOpen) el.setAttribute('data-ks-hidden-by-cta', 'true');
      else el.removeAttribute('data-ks-hidden-by-cta');

      if (shouldHide) {
        el.style.setProperty('display', 'none', 'important');
        el.style.setProperty('visibility', 'hidden', 'important');
        el.style.setProperty('pointer-events', 'none', 'important');
        el.setAttribute('data-ks-hidden-by-cart-drawer', 'true');
      } else if (el.getAttribute('data-ks-hidden-by-cart-drawer') === 'true') {
        el.style.removeProperty('display');
        el.style.removeProperty('visibility');
        el.style.removeProperty('pointer-events');
        el.removeAttribute('data-ks-hidden-by-cart-drawer');
      }
    });
  }

  function startObserver() {
    const drawer = getCartDrawer();

    const observer = new MutationObserver(function () {
      window.clearTimeout(window.__ksSmileDrawerTimer);
      window.__ksSmileDrawerTimer = window.setTimeout(updateSmileVisibility, 50);
    });

    if (drawer) {
      observer.observe(drawer, {
        attributes: true,
        attributeFilter: ['class', 'aria-hidden', 'open', 'hidden']
      });
    }

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class']
    });

    updateSmileVisibility();

    console.log(LOG, 'Initialized');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startObserver);
  } else {
    startObserver();
  }

  function scheduleUpdate() {
    window.clearTimeout(window.__ksSmileDrawerTimer);
    window.__ksSmileDrawerTimer = window.setTimeout(updateSmileVisibility, 100);
  }
  window.addEventListener('resize', scheduleUpdate);
  window.addEventListener('scroll', scheduleUpdate, { passive: true });

  setTimeout(updateSmileVisibility, 500);
  setTimeout(updateSmileVisibility, 1500);
})();